import moment from 'moment-timezone'

export const fmtNumberAsDelineatedCount = (n: number, opts?: Intl.NumberFormatOptions) => {
    return new Intl.NumberFormat('en-us', {
        ...(opts ?? {}),
    }).format(n)
}

export const fmtNumberAsPercentage = (n: number, opts?: Intl.NumberFormatOptions) => {
    return new Intl.NumberFormat('en-us', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        ...(opts ?? {}),
        style: 'percent',
    }).format(n)
}

export const fmtNumberAsCurrency = (n: number, opts?: Intl.NumberFormatOptions) => {
    return new Intl.NumberFormat('en-us', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        currency: 'USD',
        ...(opts ?? {}),
        style: 'currency',
    }).format(n)
}

export const fmtDateString = (date: string, format: string, tz?: string) => {
    const dateObj = new Date(date)
    const mm = !tz ? moment(dateObj) : moment.tz(dateObj, tz)
    return mm.format(format ?? 'LLL')
}
